import { Inject, Injectable } from '@angular/core';

import type { ApiClient } from '@packages/shared-utils';
import { API_CLIENT } from './api-client.provider';
import type { HandoffInboxResponse, HandoffRow } from './api.types';

@Injectable({ providedIn: 'root' })
export class HandoffApiService {
  constructor(@Inject(API_CLIENT) private readonly api: ApiClient) {}

  inbox(params?: {
    status?: 'PENDING' | 'TAKEN' | 'CLOSED';
    cityCode?: string;
    category?: string;
    page?: number;
    pageSize?: number;
  }): Promise<HandoffInboxResponse> {
    const status = params?.status ?? 'PENDING';
    const page = params?.page ?? 1;
    const pageSize = params?.pageSize ?? 20;
    const city = params?.cityCode ? `&cityCode=${encodeURIComponent(params.cityCode)}` : '';
    const cat = params?.category ? `&category=${encodeURIComponent(params.category)}` : '';
    return this.api.get<HandoffInboxResponse>(
      `/handoff/inbox?status=${encodeURIComponent(status)}&page=${encodeURIComponent(String(page))}&pageSize=${encodeURIComponent(String(pageSize))}${city}${cat}`,
    );
  }

  getById(handoffId: string): Promise<{ handoff: HandoffRow | null }> {
    return this.api.get<{ handoff: HandoffRow | null }>(`/handoff/${encodeURIComponent(handoffId)}`);
  }

  take(handoffId: string): Promise<{ ok: true; conversationId: string }> {
    return this.api.post<{ ok: true; conversationId: string }>(
      `/handoff/${encodeURIComponent(handoffId)}/take`,
      {},
    );
  }

  latestByConversation(conversationId: string): Promise<{ handoff: HandoffRow | null }> {
    return this.api.get<{ handoff: HandoffRow | null }>(
      `/handoff/by-conversation/${encodeURIComponent(conversationId)}`,
    );
  }

  operatorInitiate(orderId: string): Promise<{ handoffId: string; conversationId: string }> {
    return this.api.post<{ handoffId: string; conversationId: string }>(
      '/handoff/operator-initiate',
      { orderId },
    );
  }
}
